import { render } from "./CustomerContact.vue?vue&type=template&id=27ff9d56&scoped=true"
import script from "./CustomerContact.vue?vue&type=script&lang=js"
export * from "./CustomerContact.vue?vue&type=script&lang=js"

import "./CustomerContact.vue?vue&type=style&index=0&id=27ff9d56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27ff9d56"]])

export default __exports__